module.exports = "<div id=temp-chart class=sb-graph-temp-chart></div> <div id=sensor-chart class=sb-graph-sensor-chart></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/detail/graph-component/graph.html
// module id = 347
// module chunks = 0